import { render } from "./TourSection.vue?vue&type=template&id=8edf3a4c&scoped=true"
import script from "./TourSection.vue?vue&type=script&lang=js"
export * from "./TourSection.vue?vue&type=script&lang=js"

import "./TourSection.vue?vue&type=style&index=0&id=8edf3a4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8edf3a4c"]])

export default __exports__